module.exports = __webpack_public_path__ + "img/input-icon-warning.01c8c9b7.svg";